import { render } from "./JenaTable.vue?vue&type=template&id=3cb22d22"
import script from "./JenaTable.vue?vue&type=script&lang=js"
export * from "./JenaTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/afs/ASF/Release/jena/target/checkout/jena-fuseki2/jena-fuseki-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__